import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import useLazyState from '../../../hooks/useLazyState'
import LoadMask from '../../../lib/react-storefront/LoadMask'
import Head from 'next/head'
import getServerSideAPIProps from '../../../props/getServerSideAPIProps'
import { Container } from '@material-ui/core'

const useStyles = makeStyles(theme => ({}))

export default function Index(lazyProps) {
  const classes = useStyles()
  const [state] = useLazyState(lazyProps)

  let storeConfig = state.pageData.storeconfig
  return (
    <>
      {state.loading ? null : (
        <Head>
          <title>{state.pageData.title}</title>
        </Head>
      )}
      <div className="body-section">
        {state.loading ? (
          <LoadMask fullscreen />
        ) : (
          <Container maxWidth={'lg'}>
            <div className={(classes.main, 'contact-us')}>
              <h2>
                <strong>Contact Us</strong>
              </h2>
              <div className="inner-box">
                <h2 className="sub-heading">Here's Where You Can Find Us </h2>
                <p className="mb-5">
                  Thank you for choosing {storeConfig.bizname ? storeConfig.bizname : 'us'}. Please
                  write to us at <b>{storeConfig.bizemail ? storeConfig.bizemail : ''}</b> for any
                  queries and we will get back to you ASAP.
                </p>

                <div className="my-3 contact-content">
                  <div className="pro-box text-center">
                    <span>
                      <svg
                        aria-hidden="true"
                        width="20px"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="building"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        className="svg-inline--fa fa-building fa-w-14 fa-fw fa-2x"
                      >
                        <path
                          fill="currentColor"
                          d="M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                          className=""
                        ></path>
                      </svg>
                    </span>{' '}
                    Company
                  </div>
                  <div className="contact-text">
                    {' '}
                    <b>Bottlezoo</b>
                  </div>
                </div>
                <div className="my-3 contact-content">
                  <div className="pro-box text-center">
                    <span>
                      <svg
                        aria-hidden="true"
                        width="20px"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="map-marker-alt"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="svg-inline--fa fa-map-marker-alt fa-w-12 fa-fw fa-lg"
                      >
                        <path
                          fill="currentColor"
                          d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                          className=""
                        ></path>
                      </svg>
                    </span>
                    Location
                  </div>
                  <div className="contact-text">
                    {storeConfig.bizaddress ? storeConfig.bizaddress + ', ' : ''}
                    {storeConfig.bizsuburb ? storeConfig.bizsuburb + ', ' : ''}
                    {storeConfig.bizstate ? storeConfig.bizstate + ', ' : ''}
                    {storeConfig.bizcountry ? storeConfig.bizcountry + ', ' : ''}
                    {storeConfig.bizpostcode ? storeConfig.bizpostcode + ', ' : ''}
                  </div>
                </div>
                <div className="my-3 contact-content">
                  <div className="pro-box text-center">
                    <span>
                      <svg
                        aria-hidden="true"
                        width="25px"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="envelope"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="svg-inline--fa fa-envelope fa-w-16 fa-7x"
                      >
                        <path
                          fill="currentColor"
                          d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                          className=""
                        ></path>
                      </svg>
                    </span>
                    Email
                  </div>
                  <div className="contact-text">
                    <a
                      id="emailMe"
                      href={'mailto:' + storeConfig.bizemail ? storeConfig.bizemail : ''}
                    >
                      {storeConfig.bizemail ? storeConfig.bizemail : ''}
                    </a>
                  </div>
                </div>
                <div className="my-3 contact-content">
                  <div className="pro-box text-center">
                    <span>
                      <svg
                        aria-hidden="true"
                        width="25px"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="phone"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="svg-inline--fa fa-phone fa-w-16 fa-3x"
                      >
                        <path
                          fill="currentColor"
                          d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                          className=""
                        ></path>
                      </svg>
                    </span>
                    Phone
                  </div>
                  <div className="contact-text">
                    {storeConfig.biznumber ? storeConfig.biznumber : ''}
                  </div>
                </div>
              </div>
            </div>
          </Container>
        )}
      </div>
    </>
  )
}

export const getServerSideProps = getServerSideAPIProps('/store/[storeSlug]/contactus', {
  cacheControl: 'max-age=99999',
})
